// callback.component.ts
import { Component, OnInit } from '@angular/core';
import { MaterialModule } from '../material.module';
import { AuthService } from '@auth-suite-services/services';

@Component({
  selector: 'app-callback',
  standalone: true,
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  imports: [MaterialModule]
})
export class CallbackComponent implements OnInit {
  constructor(public authService: AuthService) {
    console.log('callback');
    // this.authService.handleLoginCallback();
    this.authService.handleAuthCallback();
  }
  // constructor() { }

  ngOnInit(): void {
    // console.log('callback');
    // this.authService.handleLoginCallback();
  }
}
